import React, { useEffect } from 'react';

import Pagination from '~components/atoms/Pagination';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

const DiscountPaginator = () => {
    const isLoading = useAppSelector(state => state.setting.loadings.getDiscounts);
    const { index, maxIndex } = useAppSelector(state => state.setting.discounts);

    const dispatch = useAppDispatch();

    const setIndex = (newIndex: number) => {
        if (isLoading) return;

        dispatch(combinedActions.settingSetGetDiscountSettingsIndex({ index: newIndex }));
    };

    // if maxIndex is lower then index reset index to 0
    useEffect(() => {
        if (index > maxIndex) {
            setIndex(0);
        }
    }, [maxIndex]);

    const handleOnPrev = () => {
        if (index > 0) setIndex(index - 1);
    };
    const handleOnNext = () => {
        if (index < maxIndex) setIndex(index + 1);
    };
    const handleOnFirst = () => setIndex(0);
    const handleOnLast = () => setIndex(maxIndex);

    return (
        <Pagination
            currentPage={index}
            maxPage={maxIndex}
            onPrev={handleOnPrev}
            onNext={handleOnNext}
            onFirst={handleOnFirst}
            onLast={handleOnLast}
        />
    );
};

export default DiscountPaginator;
